import React, { useState } from 'react';
import { useProductSearch } from './useDepositData';

/**
 * Form to create a new deposit (kaucja).
 * Props:
 *   onAdd(newDeposit, selectedProduct) - called with form data
 *   onCancel() - called when user cancels
 */
const DepositAddForm = ({ onAdd, onCancel }) => {
  const [newDeposit, setNewDeposit] = useState({ nazwa: '', kwota: '', opis: '', produkt_id: null });
  const [depositProductSearch, setDepositProductSearch] = useState('');
  const [selectedDepositProduct, setSelectedDepositProduct] = useState(null);

  const { results: depositProductResults, searching: depositProductSearchLoading } =
    useProductSearch(depositProductSearch);

  const handleSelectProduct = (product) => {
    setSelectedDepositProduct(product);
    setNewDeposit(prev => ({
      ...prev,
      nazwa: product.nazwa || product.name,
      kwota: product.cena_sprzedazy_brutto || product.price || '',
      produkt_id: product.id
    }));
    setDepositProductSearch('');
  };

  const handleSubmit = () => {
    onAdd(newDeposit, selectedDepositProduct, () => {
      setNewDeposit({ nazwa: '', kwota: '', opis: '', produkt_id: null });
      setSelectedDepositProduct(null);
      setDepositProductSearch('');
    });
  };

  const handleCancel = () => {
    setNewDeposit({ nazwa: '', kwota: '', opis: '', produkt_id: null });
    setSelectedDepositProduct(null);
    setDepositProductSearch('');
    onCancel();
  };

  return (
    <div style={{ padding: '15px', backgroundColor: 'var(--bg)', borderRadius: '8px', marginBottom: '20px', border: '1px solid var(--border)' }}>
      <h4 style={{ margin: '0 0 15px 0' }}>Nowa kaucja - wybierz produkt</h4>

      {/* Product search */}
      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
          1. Wyszukaj i wybierz produkt ktory bedzie kaucja:
        </label>
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            placeholder="Wpisz nazwe produktu lub kod (min. 2 znaki)..."
            value={depositProductSearch}
            onChange={(e) => setDepositProductSearch(e.target.value)}
            style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '14px' }}
          />
          {depositProductSearchLoading && (
            <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }}>
              Szukam...
            </span>
          )}
        </div>

        {depositProductResults.length > 0 && (
          <div style={{ marginTop: '10px', maxHeight: '200px', overflowY: 'auto', border: '1px solid var(--border)', borderRadius: '4px', backgroundColor: 'var(--card-bg)' }}>
            {depositProductResults.map(product => (
              <div
                key={product.id}
                onClick={() => handleSelectProduct(product)}
                style={{ padding: '10px', borderBottom: '1px solid var(--border)', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'var(--bg)'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'var(--card-bg)'}
              >
                <div>
                  <div style={{ fontWeight: '500' }}>{product.nazwa || product.name}</div>
                  <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                    Kod: {product.kod_produktu || product.barcode || '-'} |
                    Cena: {(product.cena_sprzedazy_brutto || product.price || 0).toFixed(2)} zl
                  </div>
                </div>
                <span style={{ color: 'var(--success)', fontWeight: '600' }}>Wybierz &rarr;</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedDepositProduct && (
        <div style={{ padding: '10px', backgroundColor: 'var(--success-light)', borderRadius: '4px', marginBottom: '15px' }}>
          <strong>Wybrany produkt (opcjonalnie):</strong> {selectedDepositProduct.nazwa || selectedDepositProduct.name}
          ({(selectedDepositProduct.cena_sprzedazy_brutto || selectedDepositProduct.price || 0).toFixed(2)} zl)
          <button
            onClick={() => { setSelectedDepositProduct(null); setNewDeposit(prev => ({ ...prev, produkt_id: null })); }}
            style={{ marginLeft: '10px', padding: '2px 8px', border: '1px solid var(--danger)', color: 'var(--danger)' , borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}
          >
            Usun wybor
          </button>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 2fr', gap: '10px', marginBottom: '10px' }}>
        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px' }}>Nazwa kaucji: *</label>
          <input
            type="text"
            placeholder="np. Kaucja za butelke"
            value={newDeposit.nazwa}
            onChange={(e) => setNewDeposit(prev => ({ ...prev, nazwa: e.target.value }))}
            style={{ width: '100%', padding: '8px', border: '1px solid var(--border)', borderRadius: '4px' }}
          />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px' }}>Kwota kaucji (zl): *</label>
          <input
            type="number"
            placeholder="np. 0.50"
            step="0.01"
            min="0"
            value={newDeposit.kwota}
            onChange={(e) => setNewDeposit(prev => ({ ...prev, kwota: e.target.value }))}
            style={{ width: '100%', padding: '8px', border: '1px solid var(--border)', borderRadius: '4px' }}
          />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px' }}>Opis (opcjonalnie):</label>
          <input
            type="text"
            placeholder="Opis kaucji"
            value={newDeposit.opis}
            onChange={(e) => setNewDeposit(prev => ({ ...prev, opis: e.target.value }))}
            style={{ width: '100%', padding: '8px', border: '1px solid var(--border)', borderRadius: '4px' }}
          />
        </div>
      </div>
      <p style={{ fontSize: '11px', color: 'var(--text-muted)', margin: '0 0 10px 0' }}>
        * Po utworzeniu kaucji bedziesz mogl dodac do niej produkty, ktore maja te kaucje.
      </p>
      <div style={{ display: 'flex', gap: '10px' }}>
        <button
          onClick={handleSubmit}
          style={{ padding: '8px 16px', border: '1px solid var(--success)', color: 'var(--success)' , borderRadius: '4px', cursor: 'pointer' }}
        >
          Utworz kaucje
        </button>
        <button
          onClick={handleCancel}
          style={{ padding: '8px 16px', border: '1px solid var(--text-muted)', color: 'var(--text-muted)' , borderRadius: '4px', cursor: 'pointer' }}
        >
          Anuluj
        </button>
      </div>
    </div>
  );
};

export default DepositAddForm;
